import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { grayColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  content: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '53%',
    height: 'fit-content',
    minHeight: '17.5%',
    margin: 'auto',
    padding: '10px 24px',
    inset: '0',
    textAlign: 'center',
    fontWeight: '400',
    whiteSpace: 'pre-line',
    backgroundColor: whiteColor,
    color: grayColor[16],
  },
});

const NoData = () => {
  const classes = useStyles();

  const { t } = useTranslation();

  return <p className={classes.content}>{t('dashboard.statistics.noData')}</p>;
};

export default NoData;
